module.exports = __webpack_public_path__ + "img/horus.beaae1fe.jpg";